<template>
  <div class="column content-box settings--content">
    <label class="step-title">{{
      $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.TITLE')
    }}</label>
    <div v-for="(item, index) in labels" :key="index" class="label-entry">
      <accordion-item
        :title="itemTitle(item)"
        :is-open="openAccordions[index]"
        @click="toggleAccordion(index)"
      >
        <label>
          {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.LABEL_NAME') }}
        </label>
        <multiselect
          v-model="item.selectedLabel"
          track-by="id"
          label="title"
          :placeholder="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.SELECT_LABEL')
          "
          :multiple="false"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.DESELECT_LABEL')
          "
          :close-on-select="true"
          :options="getAvailableLabels(index)"
          :allow-empty="true"
        >
          <template v-slot:noResult>
            {{
              $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.NOT_LABELS_FOUND')
            }}
          </template>
        </multiselect>
        <label>
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.LABEL_INSTRUCTION')
          }}
          <textarea
            v-model.trim="item.instruction"
            name="labels_instruction"
            class="textlong"
            :placeholder="
              $t(
                'INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.PLACEHOLDER_INSTRUCTION'
              )
            "
          />
        </label>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          size="small"
          type="button"
          @click="removeItem(index)"
        >
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.BUTTON_REMOVE_TEXT')
          }}
        </woot-button>
      </accordion-item>
    </div>
    <woot-button
      v-if="
        labels.length < labelsList.length &&
          getAvailableLabels(labels.length).length > 0
      "
      type="button"
      class="button--add-domain"
      icon="add"
      color-scheme="success"
      variant="smooth"
      size="small"
      @click="addItem"
    >
      <span>{{
        $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.BUTTON_ADD_TEXT')
      }}</span>
    </woot-button>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import assistentTabMixin from '../../mixins/assistentTabMixin';
import AccordionItem from '../../../profile/components/AccordionItem.vue';

const safeParse = val => {
  if (!val) return [];
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (e) {
    return [];
  }
};

export default {
  components: { AccordionItem },
  mixins: [assistentTabMixin],
  data() {
    return {
      labels: [],
      openAccordions: [],
    };
  },
  computed: {
    ...mapGetters({
      labelsList: 'labels/getLabels',
    }),
  },
  async created() {
    await this.$store.dispatch('labels/get');
    this.hydrate();
  },
  methods: {
    itemTitle(item) {
      if (item.selectedLabel) {
        return `${this.$t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.ITEM_PREFIX'
        )} ${item.selectedLabel.title}`;
      }
      return this.$t(
        'INTEGRATION_SETTINGS.ASSISTENT.FORM.LABELS.NEW_ITEM_TITLE'
      );
    },
    hydrate() {
      const dbLabels = safeParse(this.assistent.labels);
      this.labels = dbLabels.map(dbItem => {
        const fullLabel = this.labelsList.find(
          l => String(l.id) === String(dbItem.id)
        );
        return {
          selectedLabel: fullLabel || { id: dbItem.id, title: dbItem.label },
          instruction: dbItem.instruction,
        };
      });
      this.openAccordions = this.labels.map(() => false);
    },
    getAvailableLabels(currentIndex) {
      const selectedInOtherRows = this.labels
        .filter((item, index) => index !== currentIndex && item.selectedLabel)
        .map(item => item.selectedLabel.id);

      return this.labelsList.filter(
        label => !selectedInOtherRows.includes(label.id)
      );
    },
    toggleAccordion(index) {
      this.$set(this.openAccordions, index, !this.openAccordions[index]);
    },
    addItem() {
      this.labels.push({ selectedLabel: null, instruction: '' });
      this.openAccordions = this.openAccordions.map(() => false);
      this.openAccordions.push(true);
    },
    removeItem(index) {
      this.labels.splice(index, 1);
      this.openAccordions.splice(index, 1);
    },
    async onSubmit() {
      const mappedLabels = this.labels
        .filter(item => item.selectedLabel)
        .map(item => ({
          id: item.selectedLabel.id,
          label: item.selectedLabel.title,
          instruction: item.instruction,
        }));

      await this.saveAssistent({ labels: JSON.stringify(mappedLabels) });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
